module.exports = __webpack_public_path__ + "static/toronto-7267caa3e4a57ec0653286c24339469a.jpg";